export var FILTER_OPERATION;
(function (FILTER_OPERATION) {
    FILTER_OPERATION["in"] = "in";
    FILTER_OPERATION["contains"] = "contains";
    FILTER_OPERATION["subset"] = "subset";
    FILTER_OPERATION["superset"] = "superset";
    FILTER_OPERATION["equals"] = "equals";
    FILTER_OPERATION["notEquals"] = "notEquals";
    FILTER_OPERATION["lessThan"] = "lessThan";
    FILTER_OPERATION["lessThanOrEqual"] = "lessThanOrEqual";
    FILTER_OPERATION["greaterThan"] = "greaterThan";
    FILTER_OPERATION["greaterThanOrEqual"] = "greaterThanOrEqual";
})(FILTER_OPERATION || (FILTER_OPERATION = {}));
export var FILTER_GROUPING_OPERATION;
(function (FILTER_GROUPING_OPERATION) {
    FILTER_GROUPING_OPERATION["exclusiveOr"] = "exclusiveOr";
    FILTER_GROUPING_OPERATION["or"] = "or";
    FILTER_GROUPING_OPERATION["and"] = "and";
    FILTER_GROUPING_OPERATION["not"] = "not";
})(FILTER_GROUPING_OPERATION || (FILTER_GROUPING_OPERATION = {}));
export var FILTER_COLLATION;
(function (FILTER_COLLATION) {
    FILTER_COLLATION["ordinal"] = "ordinal";
    FILTER_COLLATION["ignorecase"] = "ignorecase";
    FILTER_COLLATION["lexicographic"] = "lexicographic";
})(FILTER_COLLATION || (FILTER_COLLATION = {}));
//# sourceMappingURL=types.js.map